const ColumnFilterDateRangePagination = ({ column, handleFilterChange }) => {
  const { filterValue, setFilter } = column

  const handleDateChange = (e, field) => {
    const value = e.target.value
    const newFilterValue = { ...(filterValue || {}), [field]: value }
    setFilter(newFilterValue)
    handleFilterChange(newFilterValue, column.id)
  }

  const dateFrom = filterValue?.dateFrom || ''
  const dateTo = filterValue?.dateTo || ''

  return (
    <div className="p-1 w-full">
      <div className="flex space-x-2">
        <input
          type="date"
          className="bg-white border-neutral text-secondary rounded-lg p-2 w-24"
          value={dateFrom}
          onChange={(e) => handleDateChange(e, 'dateFrom')}
          placeholder="From"
        />
        <input
          type="date"
          className="bg-white border-neutral text-secondary rounded-lg p-2 w-24"
          value={dateTo}
          onChange={(e) => handleDateChange(e, 'dateTo')}
          placeholder="To"
        />
      </div>
    </div>
  )
}

export default ColumnFilterDateRangePagination
